export function formatarTelefone(telefone?: string) {
  if (telefone) {
    let tel = telefone?.replace(/\D/g, '');

    if (tel?.length === 13) {
      tel = telefone?.replace(/^(\d{2})(\d{2})(\d{4,5})(\d{4})$/, '+$1 ($2) $3-$4');
      return tel;
    }
    tel = telefone?.replace(/^(\d{2})(\d{4,5})(\d{4})$/, '($1) $2-$3');
    return tel;
  }
  return '';
}
